/**
 * Shared layout tokens for Event QR Check-in and Record & Close modals
 * (left color bar + outcome message box).
 *
 * Schema mirrors EventQRCheckIn scan / waitlist confirmation bodies.
 */
export const SCAN_MODAL_TONES = {
  success: { border: "#10B981", labelBg: "#D1FAE5", labelColor: "#065F46" },
  error: { border: "#F43F5E", labelBg: "#FFE4E6", labelColor: "#BE123C" },
  alreadyCheckedIn: { border: "#64748B", labelBg: "#F1F5F9", labelColor: "#475569" },
  waitlistGeneric: { border: "#6366F1", labelBg: "#EEF2FF", labelColor: "#4338CA" },
  waitlistPrompt: { border: "#F59E0B", labelBg: "#FEF3C7", labelColor: "#B45309" },
  waitlistDeclined: { border: "#334155", labelBg: "#E2E8F0", labelColor: "#334155" },
};

/** Left accent bar + padding (matches EventQR scan / waitlist modal body). */
export function scanModalBodyOuterStyle(tone) {
  return {
    borderLeft: `4px solid ${tone.border}`,
    paddingLeft: "12px",
    margin: "-2px 0 0 0",
  };
}

export const SCAN_MODAL_DETAIL_LABEL_STYLE = {
  fontSize: "11px",
  color: "#6c757d",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  marginBottom: "2px",
};

export const SCAN_MODAL_DETAIL_NAME_STYLE = {
  margin: "0 0 12px 0",
  fontSize: "15px",
  fontWeight: 600,
  color: "#212529",
};

export const SCAN_MODAL_DETAIL_META_STYLE = {
  margin: "0 0 0 0",
  fontSize: "13px",
  color: "#495057",
};

/** Colored outcome / callout block inside the modal body. */
export function scanModalOutcomeBoxStyle(tone, fontWeight) {
  return {
    marginTop: "12px",
    padding: "10px 12px",
    borderRadius: "6px",
    background: tone.labelBg,
    color: tone.labelColor,
    fontSize: "13px",
    lineHeight: 1.45,
    fontWeight,
  };
}
